import $ from "jquery";
import "select2";

$("select").select2({
  theme: "form",
  minimumResultsForSearch: -1,
  width: "100%",
});
